import { AI_CONFIGURATION_QUERY_KEY } from "@entities/AIControls/lib/constants";
import { IAIConfiguration } from "@entities/AIControls/lib/types";
import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import { BriefService } from "../services/brief.service";

export default function useEditAIConfigurationSettings() {
    const { mutate: editAiExecutionSettings, error: editAiExecutionSettingsError, isSuccess: isEditAiExecutionSettingsSuccess, isLoading: isEditAiExecutionSettingsLoading } = useMutation({
        mutationFn: (payload: Partial<IAIConfiguration>) => BriefService.editAiExecutionSettings(payload),
        options: {
            skipInvalidation: true
        },
        onSuccess: (c, data, params) => {
            c.setQueryData(
                [...AI_CONFIGURATION_QUERY_KEY],
                (oldData: BackednResponse<Partial<IAIConfiguration>>) => ({
                    ...oldData,
                    data: {
                        ...oldData?.data,
                        isAiChecksEnabled: data?.data?.isAiChecksEnabled,
                        isAiConsistencyCheck: data?.data?.isAiConsistencyCheck,
                        isAiScriptVsDraftingConsistencyCheck:
                            data?.data?.isAiScriptVsDraftingConsistencyCheck,
                        isAiSafetyChecks: data?.data?.isAiSafetyChecks,
                        isAiPerformanceChecks: data?.data?.isAiPerformanceChecks,
                        isAiBrandGuardRailsChecks: data?.data?.isAiBrandGuardRailsChecks,
                        isAiAdvancedPromptingChecks:
                            data?.data?.isAiAdvancedPromptingChecks,
                        aiBrandGuardRailsChecks: data?.data?.aiBrandGuardRailsChecks,
                        aiAdvancedPromptingChecks: data?.data?.aiAdvancedPromptingChecks,
                    },
                })
            );
        }
    });
    return {
        editAiExecutionSettings,
        editAiExecutionSettingsError,
        isEditAiExecutionSettingsSuccess,
        isEditAiExecutionSettingsLoading
    };
}